import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// Example: Pilot feature for standards mastery analytics (real data, role-aware)
const AcademicEyePilot = () => {
  // Always call hooks at the top level
  const { user, token } = useAuth();
  const [analytics, setAnalytics] = useState<any>(null);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>("");

  useEffect(() => {
    async function fetchAnalytics() {
      setLoading(true);
      setError("");
      try {
        const res = await fetch('/api/analytics/standards', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!res.ok) throw new Error('Failed to fetch analytics');
        const data = await res.json();
        setAnalytics(data);
      } catch (err: any) {
        setError('Could not load analytics.');
      } finally {
        setLoading(false);
      }
    }
    if (token) fetchAnalytics();
  }, [token]);

  if (!user) return <div>Please log in to view pilot analytics.</div>;

  return (
    <div style={{ maxWidth: 900, margin: '40px auto', padding: 32, borderRadius: 12, background: '#fff', border: '2px solid #3256a2', boxShadow: '0 2px 16px #e0e0e0' }}>
      <h1 style={{ color: '#3256a2', fontSize: 28, marginBottom: 8 }}>Academic Eye Pilot</h1>
      <p style={{ color: '#5f949b', marginBottom: 24, fontSize: 18 }}>PK-12 Standards Mastery Analytics (Pilot Feature)</p>
      {loading ? (
        <div>Loading analytics...</div>
      ) : error ? (
        <div style={{ color: 'red' }}>{error}</div>
      ) : analytics ? (
        <div>
          <h2 style={{ color: '#3256a2', fontSize: 20, marginBottom: 12 }}>Summary</h2>
          <ul style={{ color: '#5f949b', fontSize: 16 }}>
            {analytics.summary && analytics.summary.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          {/* Example: standards breakdown */}
          {analytics.standards && (
            <div style={{ marginTop: 24 }}>
              <h3 style={{ color: '#3256a2', fontSize: 18 }}>Standards Breakdown</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, border: '2px solid #5f949b', fontSize: 15 }}>
                <thead style={{ background: '#3256a2' }}>
                  <tr>
                    <th style={{ color: '#ffa962', fontWeight: 700, padding: 12 }}>Standard</th>
                    <th style={{ color: '#ffa962', fontWeight: 700, padding: 12 }}>Mastery %</th>
                  </tr>
                </thead>
                <tbody>
                  {analytics.standards.map((s, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#5f949b10' }}>
                      <td style={{ color: '#3256a2', padding: 12 }}>{s.name}</td>
                      <td style={{ color: s.mastery >= 85 ? '#3256a2' : s.mastery >= 70 ? '#ffa962' : '#000', fontWeight: 700, padding: 12 }}>{s.mastery}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <div>No analytics data available.</div>
      )}
      <div style={{ color: '#3256a2', fontSize: 15, marginTop: 32 }}>
        <strong>Pilot Notice:</strong> This feature is in early access. Data is live and role-based. Feedback welcome!
      </div>
    </div>
  );
};

export default AcademicEyePilot;
